<template>
  <v-card outlined color="#e8eaf6" class="mt-1 pa-1" @click="isList ? navigateOrder(model.id) : false">
    <v-card-text class="pa-1 pt-0 pb-0">
      <v-row>
        <v-col cols="2" class="mt-2 pa-0 pl-1">
          <span class="body-2">{{ model.number }}</span>
          <br>
          <span class="body-2 d-inline-block text-truncate" style="max-width: 75px;">{{ model.salesreference }}</span>
        </v-col>
        <v-col :cols="isList ? 10 : 8" class="pa-0 pl-5">
          <v-row class="mt-2">
            <v-col cols="12" class="pa-0">
              <template v-if="type === 'supplier'">
                <span class="body-2">{{ model.suppliername }}</span>
              </template>
              <template v-else-if="type === 'transfer'">
                S: {{ model.sourcewarehouse }}
              </template>
              <template v-else-if="type === 'adjustment'">
                W: {{ model.warehousename }}
              </template>
            </v-col>
            <v-col cols="12" class="pa-0" v-if="type === 'transfer'">
              D: {{ model.destwarehouse }}
            </v-col>
            <v-col cols="3" class="pa-0">
              <span class="body-2">{{ $t('message.order.orderedshort') }}: {{ model.orderdate | dateFormat }}</span>
            </v-col>
            <v-col cols="3" class="pa-0">
              <span class="body-2">{{ $t('message.order.confirmedshort') }}: {{ model.confirmed_date | dateFormat }}</span>
            </v-col>
            <v-col cols="3" class="pa-0">
              <span class="body-2">{{ $t('message.order.requestedshort') }}: {{ model.estimated_date | dateFormat }}</span>
            </v-col>
            <v-col cols="3" class="pa-0" v-if="isList && (type === 'supplier' || type === 'adjustment')">
              <template v-if="type === 'supplier'"><span class="body-2">{{ $t('message.product.qtyShort') }}:</span></template>
              <template v-if="type === 'supplier'"><span class="body-2">{{ model.orderedqty | absoluteNumber }}/{{ model.receivedqty | absoluteNumber }}</span></template>
              <template v-else-if="type === 'adjustment'">{{ model.qty | absoluteNumber }}</template>
            </v-col>
          </v-row>
        </v-col>
        <v-col cols="2" v-if="!isList" class="mt-4 pa-0 pr-2 text-right">
          <h4>
            +{{ model.receivedqty | absoluteNumber }}
          </h4>
        </v-col>
      </v-row>
    </v-card-text>
  </v-card>
</template>
<script>
export default {
  props: {
    isList: {
      type: Boolean
    },
    model: {
      type: Object
    },
    type: {
      type: String
    }
  },
  methods: {
    navigateOrder (id) {
      let url = ''
      switch (this.type) {
        case 'supplier':
          url = 'supplier_orders'
          break
        case 'transfer':
          url = 'transfer_orders'
          break
        case 'adjustment':
          url = 'adjustment_orders'
          break
        default:
          break
      }
      this.$router.push(`/${url}/${id}`)
    }
  }
}
</script>
